<template>
  <div class="alignment">
    <template>
      <v-layout row wrap>
        <v-flex xs6 class="text-xs-left">
          <h3 class="styleHeader">
            {{ $t("pages.Extractions.Index.Estrazione") }}
          </h3>
        </v-flex>
        <v-flex>
          <v-btn
            class="right white--text styleHeader styleAlignamentAddButton"
            :to="$i18nRoute({ name: 'ExtractionsCreate' })"
            color="#279947"
          >
            <v-icon left>add</v-icon>
            {{ $t("pages.Extractions.Index.Aggiungi") }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="[
          {
            text: this.currentLanguage.t('pages.Extractions.Index.Nome'),
            value: 'name'
          },
          {
            text: this.currentLanguage.t('pages.Extractions.Index.Categoria'),
            value: 'description'
          },
          { text: '' },
          { text: '' },
          { text: '' }
        ]"
        :items="extractions"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.description }}</td>
          <td>
            <v-btn flat icon class="right" @click="editItem(props.item)">
              <v-icon>edit</v-icon>
            </v-btn>
          </td>
          <td>
            <v-btn flat icon class="right" @click="openDialog(props.item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
          <td>
            <v-btn flat icon class="right" @click="duplicate(props.item)">
              <v-icon>file_copy</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
      <v-alert
        class="centerButton"
        :value="conferma"
        transition="scale-transition"
      >
        {{ $t("pages.Extractions.Index.ConfermaElimina") }}
        <v-btn @click="deleteItem()">{{
          $t("pages.Extractions.Index.Conferma")
        }}</v-btn>
        <v-btn @click="conferma = !conferma">{{
          $t("pages.Extractions.Index.Annulla")
        }}</v-btn>
      </v-alert>
    </template>
  </div>
</template>

<script>
import extractionApi from "../../apiSmartLogistics/extractionApi.js";
import router from "@/router/index.js";

import { Trans } from "@/plugins/Translation";
export default {
  data() {
    return {
      extractions: [],
      dialog: "",
      selectedItem: "",
      conferma: false
    };
  },
  computed: {
    currentLanguage() {
      return Trans.i18n;
    }
  },
  methods: {
    editItem(item) {
      router.push({ name: "ExtractionsCreate", params: { id: item.id } });
    },
    duplicate(item) {
      router.push({
        name: "ExtractionsCreate",
        params: { id: item.id, duplicate: true }
      });
    },
    deleteItem() {
      let item = this.selectedItem;
      extractionApi.DeleteExtraction(item.id).then(() => {
        this.getExtractions();
        this.conferma = false;
      });
    },
    openDialog(item) {
      this.conferma = true;
      this.selectedItem = item;
    },
    getExtractions() {
      extractionApi.GetExtractions().then(response => {
        this.extractions = response.data;
      });
    }
  },
  created() {
    this.getExtractions();
  }
};
</script>
